import { OTHER_LABEL } from '../checkboxgroup/EhsFormioCheckboxGroupUtil';
import { isEmptyString } from '../../../../util';

export type EhsFormioRadioConstructor = {
  classNames: string;
  classNamesLabel: string;
  classNamesRadios: string;
  radioOptions: Array<RadioOption>;
};
/**
 * @param classNames a string separated by spaces that will be added as classNames
 * @param radioOptions the options the user will be able to select
 */
export type EhsFormioRadioSettings = {
  classNames?: string;
  classNamesLabel?: string;
  classNamesRadios?: string;
  radioOptions: Array<RadioOption>;
  defaultValue?: string | RadioOption;
};

export type RadioOption = {
  radioLabel: string;
  radioValue: string;
  default: boolean;
};

export function buildDefaultRadioOptionFromString(
  labelOrValue: string | undefined,
  radioOptions: RadioOption[]
): RadioOption | null {
  // non-other option found
  const matchingItem = radioOptions.find(
    option => option.radioValue === labelOrValue
  );

  if (matchingItem) {
    return matchingItem;
  }

  // ensure other option is there
  const otherItem = radioOptions.find(
    option => option.radioValue === OTHER_LABEL
  );

  if (!otherItem) {
    return null;
  }

  // inside a repeating group with no value for this row — return a default
  // without mutating the shared radioOptions objects
  if (!labelOrValue) {
    return radioOptions.find(option => option.default) ?? null;
  }

  // return a copy with the other value set
  if (isEmptyString(labelOrValue)) {
    return radioOptions.find(option => option.default) ?? null;
  }
  return { ...otherItem, radioLabel: labelOrValue };
}

/**
 * Tries to retrieve a valid default value.
 *
 * @param defaultValue defaultValue passed by formio
 * @param radioOptions the options the user will be able to select
 */
export function getOrBuildDefaultRadioOption(
  radioOptions: RadioOption[],
  defaultValue?: RadioOption | string
): RadioOption | null {
  if (isRadioValueRadioOption(defaultValue)) {
    return defaultValue;
  }

  return buildDefaultRadioOptionFromString(defaultValue, radioOptions);
}

export function isRadioValueString(
  value?: string | RadioOption
): value is string {
  return typeof value === 'string';
}

export function isRadioValueRadioOption(
  value?: string | RadioOption
): value is RadioOption {
  return typeof value === 'object' && 'radioValue' in value;
}
